import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
    ApplicationConfigService,
    BaseContainer,
    LocalStorageID,
    ReadExportMode,
    ShHtmlParserComponent,
    ShIconModule
} from '@stylehaven/components';

@Component({
    standalone: true,
    selector: 'med-read-export-mode-notification',
    templateUrl: './read-export-mode-notification.component.html',
    styleUrls: ['./read-export-mode-notification.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TranslateModule, ShIconModule, ShHtmlParserComponent]
})
export class ReadExportModeNotificationContainerComponent extends BaseContainer implements OnInit {
    private readonly LOCAL_STORAGE_ID: string = LocalStorageID.ReadExportOnlyNotification;

    private closedNotification$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public showNotification$: Observable<boolean>;
    public notificationMsgKey$: Observable<string>;

    constructor(private readonly configService: ApplicationConfigService) {
        super();
    }

    ngOnInit() {
        this.initReadExportModeSetting();
    }

    private initReadExportModeSetting() {
        const readExportMode$: Observable<ReadExportMode> = this.configService
            .getConfig()
            .pipe(map(config => config.readExportMode ?? ReadExportMode.None));

        this.showNotification$ = combineLatest([readExportMode$, this.closedNotification$]).pipe(
            map(
                ([readExportMode, closed]) =>
                    readExportMode !== ReadExportMode.None && !closed && !this.hasClosedNotification()
            )
        );
        this.notificationMsgKey$ = readExportMode$.pipe(
            map(readExportMode => `components.read-export-mode.${readExportMode}`)
        );
    }

    private hasClosedNotification(): boolean {
        const closedNotification = localStorage.getItem(this.LOCAL_STORAGE_ID);

        if (!closedNotification) {
            return false;
        }

        return !!closedNotification;
    }

    public onClose(): void {
        localStorage.setItem(this.LOCAL_STORAGE_ID, 'true');
        this.closedNotification$.next(true);
    }
}
